import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Beach } from '@/types/beach';

type GetBeachResponse = {
  exception: null | string;
  state: number;
  value: Beach[];
  isFaulted: boolean;
  isSuccess: boolean;
};

export const getBeach = async (): Promise<Beach[]> => {
  try {
    const res = await apiClient.post<GetBeachResponse>(Endpoints.BeachList, {});
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
